import {lazy} from "react";
import {Route} from "react-router";
import {
    HOME_PAGE_URI,
    PROJECTS_PAGE_URI,
    PROJECT_PAGE_URI,
    PARTICIPANTS_PAGE_URI,
    PARTICIPANT_PROFILE_PAGE_URI,
    EXEL_PAGE_URI,
    STATISTICS_PAGE_URI,
    NOTIFICATIONS_PAGE_URI
} from "../../../constants/uri.constant";

import ProjectList from "../../../page/ProjectList";
import Project from "../../../page/Project";
import Participants from "../../../page/Participants";
import ParticipantProfile from "../../../page/ParticipantProfile";
import Workspaces from "../../../page/Workspaces";
import Home from "../../../page/Home";
import Exel from "../../../page/Exel";
import Statistics from "../../../page/Statistics";
import Notifications from "../../../page/Notifications";

export const webRoutes = () => {
    let routes = [
        {
            layout: Route,
            path: HOME_PAGE_URI,
            element: <Home />,
        },
        {
            layout: Route,
            path: "/",
            exact: true,
            element: <Home />,
        },
        {
            layout: Route,
            path: EXEL_PAGE_URI,
            element: <Exel />,
        },
        {
            layout: Route,
            path: STATISTICS_PAGE_URI,
            element: <Statistics />,
        },
        {
            layout: Route,
            path: NOTIFICATIONS_PAGE_URI,
            element: <Notifications />,
        },
        {
            layout: Route,
            path: PROJECTS_PAGE_URI,
            element: <ProjectList />,
        },
        {
            layout: Route,
            path: PROJECT_PAGE_URI,
            element: <Project />,
        },
        {
            layout: Route,
            path: PARTICIPANTS_PAGE_URI,
            element: <Participants />,
        },
        {
            layout: Route,
            path: PARTICIPANT_PROFILE_PAGE_URI,
            element: <ParticipantProfile />,
        },
        {
            layout: Route,
            path: "/workspaces",
            element: <Workspaces />,
        },
        {
            layout: Route,
            path: "*",
            exact: true,
            element: lazy(() => import('../../../page/NotFound'))
        }
    ]

    return routes.reduce((routes, route) => {
        if (route.hideLayout) {
            return {
                ...routes,
                withoutLayout: [...routes.withoutLayout, route]
            }
        }

        return {
            ...routes,
            withLayout: [...routes.withLayout, route]
        }
    }, { withLayout: [], withoutLayout: [] })
}
